import { Facebook, Instagram, Telegram } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";

// Socail Media Links Const
const FACEBOOK_URL =
  "https://www.facebook.com/share/1F942TC2iB/?mibextid=wwXIfr";
const INSTAGRAM_URL =
  "https://www.instagram.com/us2tjk?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==";
const TELEGRAM_URL = "https://t.me/us2tjk";

// Simple and readable: each button is a small, clickable icon.
export function InstagramButton() {
  return (
    <IconButton
      aria-label="US2TJK on Instagram"
      size="small"
      component="a"
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: "rgba(255, 255, 255, 0.7)",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: "#F7A81B", // Using website orange color
          color: "white",
          transform: "translateY(-2px)",
          boxShadow: "0 4px 12px rgba(247, 168, 27, 0.5)", // Using website orange color with opacity
        },
      }}
    >
      <Instagram fontSize="small" />
    </IconButton>
  );
}

export function FacebookButton() {
  return (
    <IconButton
      aria-label="US2TJK on Facebook"
      size="small"
      component="a"
      href={FACEBOOK_URL}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: "rgba(255, 255, 255, 0.7)",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: "#F7A81B", // Using website orange color
          color: "white",
          transform: "translateY(-2px)",
          boxShadow: "0 4px 12px rgba(247, 168, 27, 0.5)", // Using website orange color with opacity
        },
      }}
    >
      <Facebook fontSize="small" />
    </IconButton>
  );
}

export function TelegramButton() {
  return (
    <IconButton
      aria-label="US2TJK on Telegram"
      size="small"
      component="a"
      href={TELEGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: "rgba(255, 255, 255, 0.7)",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: "#F7A81B", // Using website orange color
          color: "white",
          transform: "translateY(-2px)",
          boxShadow: "0 4px 12px rgba(247, 168, 27, 0.5)", // Using website orange color with opacity
        },
      }}
    >
      <Telegram fontSize="small" />
    </IconButton>
  );
}

// Default export: renders the same row used in the footer.
export default function SocialMedia() {
  return (
    <Stack direction="row" spacing={1.5}>
      <InstagramButton />
      <FacebookButton />
      <TelegramButton />
    </Stack>
  );
}
